import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiIconButton } from 'noddi-ui-web';
import { tracking } from 'noddi-web';
import { useCallback, useRef, useState } from 'react';
import { NavioContactChatWidgetProps } from './NavioContactChatWidgetContent';

const TELIA_WIDGET_URL =
  'https://chat.teliasmartconnect.com/chat.js?widget-id=VTJGc2RHVmtYMSt1S2NXeEk0K09nMW9yOGdIZ2h5U1VZc0gyTWlUU2VNaz0=';

declare global {
  var tsc_chat_config: { themeColor: string; buttonText: string } | undefined;
}

const hideTeliaButton = () => {
  if (document.getElementById('tsc-chat-style')) {
    return;
  }
  const style = document.createElement('style');
  style.id = 'tsc-chat-style';
  style.textContent = '#tsc-chat .tsc-chat-widget-button { display: none !important; }';
  document.head.appendChild(style);
};

const clickTeliaButton = () => {
  const button = document.querySelector('#tsc-chat .tsc-chat-widget-button') as HTMLElement | null;
  button?.click();
};

export const BestdriveContactChatWidget = ({ size = 'medium', className }: NavioContactChatWidgetProps) => {
  const scriptsInjectedRef = useRef(false);
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  const ensureWidgetAndOpen = useCallback(() => {
    if (scriptsInjectedRef.current && isWidgetReady) {
      clickTeliaButton();
      return;
    }

    if (scriptsInjectedRef.current) {
      return;
    }

    scriptsInjectedRef.current = true;

    globalThis.tsc_chat_config = {
      themeColor: '#E68415',
      buttonText: 'Chat med oss'
    };

    const widgetScript = document.createElement('script');
    widgetScript.id = 'chat-widget';
    widgetScript.type = 'module';
    widgetScript.src = TELIA_WIDGET_URL;
    widgetScript.onload = () => {
      // Wait for the widget to render its DOM, then hide its button
      const observer = new MutationObserver(() => {
        const teliaButton = document.querySelector('#tsc-chat .tsc-chat-widget-button');
        if (teliaButton) {
          observer.disconnect();
          hideTeliaButton();
          setIsWidgetReady(true);
          clickTeliaButton();
        }
      });
      observer.observe(document.getElementById('tsc-chat') ?? document.body, {
        childList: true,
        subtree: true
      });
    };
    document.body.appendChild(widgetScript);
  }, [isWidgetReady]);

  const triggerChat = useCallback(() => {
    tracking.track('helpScoutChatOpened');
    ensureWidgetAndOpen();
  }, [ensureWidgetAndOpen]);

  return (
    <>
      <div id='tsc-chat' />
      <div className={className}>
        {size === 'small' ? (
          <NoddiIconButton variant='outline' onClick={triggerChat} iconName='MessageSquare' aria-label={t`Chat`} />
        ) : (
          <NoddiButton startIcon='MessageSquare' variant='outline' onClick={triggerChat}>
            <Trans>Chat</Trans>
          </NoddiButton>
        )}
      </div>
    </>
  );
};
